export enum DiscountType {
	Membership = 'membership',
	Partners = 'partners',
	StudentThursday = 'student_thursday',
	PiggyRewards = 'piggy_rewards',
	Other = 'other',
	None = 'none',
}
